import { keyPair } from "@repo/models";
import { useCallback } from "react";

import { RepSegment } from "../models";
import * as Queries from "./queries";
import { useQueryWrapper, useRepPortalApi } from "./repPortalApi";

export function useRepSegmentsApi(repId: number) {
	const { Get, Post } = useRepPortalApi();

	async function getRepresentativeSegments() {
		return !repId ? null : await Get<RepSegment[]>("GetRepresentativeSegments", { repId });
	}

	async function addRepresentativeSegment(stateId: number) {
		return await Post<number, null>("AddRepresentativeSegment", { repId, stateId });
	}

	const useRepSegmentsQuery = () => useQueryWrapper(Queries.ONBOARDING_SEGMENTS, [repId], getRepresentativeSegments);

	const { loaded, data } = useRepSegmentsQuery();

	const useOnboardingSegmentsQuery = useCallback(() => {
		return {
			loaded,
			onboardingSegments: data
				?.sort((a, b) => a.id - b.id)
				?.map((rs) => ({ id: rs.id, value: rs.name }) as keyPair),
		};
	}, [loaded, data]);

	const getRepSegment = useCallback(
		(repSegmentId: number) => {
			if (!loaded) return null;
			return data.find((repSegment) => repSegment.id === repSegmentId);
		},
		[loaded, data],
	);

	return {
		useRepSegmentsQuery,
		addRepresentativeSegment,
		useOnboardingSegmentsQuery,
		getRepSegment,
	};
}
